/**
 * Localized country name for an ISO 3166-1 alpha-2 code ("RO" → "România"
 * in ro, "Romania" in en). Falls back to the code when the runtime has no
 * DisplayNames data.
 */
export function regionName(code: string | null | undefined, locale: string): string {
  const cc = (code ?? "").trim().toUpperCase();
  if (!cc) return "";
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(cc) ?? cc;
  } catch {
    return cc;
  }
}
